import { OfficialWebsiteUrlProvider } from '@affine/component/affine-other-page-layout';
import type { PropsWithChildren } from 'react';

import { useInstanceOfficialWebsiteUrl } from '../instance-branding';

export const ServerOfficialWebsiteProvider = ({
  children,
}: PropsWithChildren) => {
  const officialWebsiteUrl = useInstanceOfficialWebsiteUrl();

  return (
    <OfficialWebsiteUrlProvider officialWebsiteUrl={officialWebsiteUrl}>
      {children}
    </OfficialWebsiteUrlProvider>
  );
};
